const OTP_PATTERN = /^[0-9]{6}$/

const isOTP = maybeOTP =>
  typeof maybeOTP === 'string' && OTP_PATTERN.test(maybeOTP)

export default isOTP
